import clsx from "clsx";
import { ReactNode } from "react";

import { View, Text, Tooltip, Icon } from ".";
import { Style } from "../../utils/types";

type FieldLabelProps = {
  className?: string;
  children: ReactNode;
  label?: ReactNode;
  error?: string;
  style?: Style;
  tooltip?: ReactNode;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
};

export const FieldLabel = ({ className, children, label, error, style, tooltip, tooltipPlacement = "top" }: FieldLabelProps) => {
  return (
    <View
      className={clsx("w-full flex flex-col items-start justify-start relative", className)}
      style={style}
    >
      {label && (
        <>
          {tooltip ? (
            <Tooltip
              content={tooltip}
              placement={tooltipPlacement}
              className="flex items-center gap-1 cursor-pointer mb-1"
            >
              <label className="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer">{label}</label>
              <Icon
                name="info"
                size={16}
                className="text-gray-700 dark:text-gray-300 mt-[1px]"
              />
            </Tooltip>
          ) : (
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{label}</label>
          )}
        </>
      )}
      {children}
      {error && <Text className="mt-1 text-sm text-error">{error}</Text>}
    </View>
  );
};
